import React, { useContext, useState } from "react";
import FormTriggers from "../../../layouts/FormTriggers";
import { format } from "date-fns";
import RadioButtons from "../../../layouts/RadioButtons";
import { axios_instance } from "../../../api/axios_instance";
import FormButtons from "./FormButtons";
import { toast } from "react-toastify";
import {
  checkHoldCase,
  disbursalDetailFormValidate,
  getCompletedStepDetails,
  holdCaseMessage,
  validateIndividualAmount,
  validateNetAmount,
} from "../../../utils/detail";
import { DetailFormContext } from "../../../ContextAPI/context";

const DisbursalDetailCheck = ({
  fieldValues,
  stepSelected,
  handleNextStep,
  user,
  isVerificationRequired,
  Message,
  dtsCheckpoints,
  fetchCaseData,
  caseDetails,
}) => {
  const { panelTitle, stepTitle, setDetailFormButtonClicked } =
    useContext(DetailFormContext);
  const { stepDetails, requiredSubStepFields } = fieldValues;
  const { checklist, btnDraftType } = stepDetails;

  const {
    finance_lead_id,
    id,
    bank_id,
    formal_do_doc,
    bank_los_id,
    disbursed_date,
    disbursement_picked_date,
    bank_name,
    net_disbursement_amount,
    deduction_loansuraksha_amount,
    deduction_stampduty_amount,
    deduction_advemi_amount,
    deduction_others_amount,
    gross_disbursement_amount,
    lead_disbursed_amt,
    clear_rcu_status,
    is_prepayment_raised,
    insurance,
    stage,
    sub_stage,
    step_details,
    maker_id,
  } = caseDetails;

  const initialState = {
    los_id: bank_los_id ? bank_los_id : "",
    formalDoDoc: formal_do_doc,
    netDisbursementAmount: net_disbursement_amount
      ? net_disbursement_amount
      : lead_disbursed_amt,
    deductionLoanSurakshaAmount: deduction_loansuraksha_amount
      ? deduction_loansuraksha_amount
      : "0",
    deductionStampdutyAmount: deduction_stampduty_amount
      ? deduction_stampduty_amount
      : "0",
    deductionAdvemiAmount: deduction_advemi_amount
      ? deduction_advemi_amount
      : "0",
    deductionOthersAmount: deduction_others_amount
      ? deduction_others_amount
      : "0",
    clearRCUStatus: clear_rcu_status,
    grossAmount: gross_disbursement_amount
      ? gross_disbursement_amount
      : lead_disbursed_amt,
    showFormalDoDocError: false,
    showLosIdError: false,
    showNetAmountError: false,
    showLoanSurakshaError: false,
    showStampDutyError: false,
    showAdvancedEMIError: false,
    showOtherAmountError: false,
    showRCUOkError: false,
  };
  const [state, setState] = useState(initialState);

  // Check visibility conditions for each field
  const isFormalDoVisible = requiredSubStepFields?.formal_do?.is_visible === 1;

  const isLosIdVisible = requiredSubStepFields?.los_id?.is_visible === 1;

  const isDisbursementDateVisible =
    requiredSubStepFields?.disbursement_date?.is_visible === 1;

  const isFinancierVisible = requiredSubStepFields?.financier?.is_visible === 1;
  const isNetAmountVisible =
    requiredSubStepFields?.net_amount?.is_visible === 1;

  const isLoanSurakshaVisible =
    requiredSubStepFields?.loan_suraksha?.is_visible === 1;

  const isStampDutyVisible =
    requiredSubStepFields?.stamp_duty?.is_visible === 1;

  const isAdvancedEMIVisible =
    requiredSubStepFields?.advanced_emi?.is_visible === 1;

  const isOtherDeductionsVisible =
    requiredSubStepFields?.other_deductions?.is_visible === 1;

  const isGrossAmountVisible =
    requiredSubStepFields?.gross_amount?.is_visible === 1;

  const isRCUOkVisible = requiredSubStepFields?.rcu_ok?.is_visible === 1;

  // Check if any field requires verification
  const calculatedIsVerificationRequired =
    isFormalDoVisible ||
    isLosIdVisible ||
    isDisbursementDateVisible ||
    isFinancierVisible ||
    isNetAmountVisible ||
    isLoanSurakshaVisible ||
    isStampDutyVisible ||
    isAdvancedEMIVisible ||
    isOtherDeductionsVisible ||
    isGrossAmountVisible ||
    isRCUOkVisible;

  const saveDetails = async () => {
    const stepDetails = getCompletedStepDetails(
      step_details,
      sub_stage,
      stepSelected
    );
    await axios_instance({
      url: "/dts/saveDisbursalDetails",
      method: "POST",
      data: {
        finance_lead_id,
        form: stepSelected,
        stage: +stage,
        sub_stage: +sub_stage,
        type: btnDraftType,
        step_details: stepDetails,
        insurance,
        bank_id,
        is_prepayment_raised: is_prepayment_raised,
        formal_do_doc: state.formalDoDoc,
        bank_los_id: state.los_id,
        deduction_loansuraksha_amount: state.deductionLoanSurakshaAmount,
        deduction_stampduty_amount: state.deductionStampdutyAmount,
        deduction_advemi_amount: state.deductionAdvemiAmount,
        deduction_others_amount: state.deductionOthersAmount,
        net_disbursement_amount: state.netDisbursementAmount,
        disbursement_picked_date: disbursement_picked_date
          ? format(new Date(disbursement_picked_date), "dd-MM-yyyy")
          : format(new Date(disbursed_date), "dd-MM-yyyy"),
        gross_disbursement_amount: state.grossAmount,
        clear_rcu_status: state.clearRCUStatus,
        disbursement_id: +id,
      },
    });
    await fetchCaseData();
  };

  const handleSaveAndNext = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (
        !disbursalDetailFormValidate(state, setState, requiredSubStepFields)
      ) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
      handleNextStep();
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleSaveAsDraft = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (
        !disbursalDetailFormValidate(state, setState, requiredSubStepFields)
      ) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleInputChange = (inputName, value, errorId) => {
    setState({ ...state, [inputName]: value, [errorId]: false });
  };

  const handleBlurNetAmount = () => {
    const result = validateNetAmount(state, setState);
    showToast(result);
  };

  const handleBlurIndividualAmount = (field, errorId) => {
    const result = validateIndividualAmount(state, setState, field, errorId);
    showToast(result);
  };

  const showToast = (result) => {
    const { msg, error } = result;
    if (!msg) return;
    toast.dismiss();
    if (error) {
      toast.error(msg, { theme: "colored" });
    } else {
      toast(
        <>
          <span className="glyphicon glyphicon-ok-sign"></span>
          {` ${msg}`}
        </>
      );
    }
  };

  return (
    <>
      <div
        className="table-responsive chklist-box-scroll mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        data-mcs-theme="minimal-dark"
      >
        {isVerificationRequired && calculatedIsVerificationRequired ? (
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            >
              <form id="disbursal_detail_check">
                <table className="table table-bordered disburse-table">
                  <thead>
                    <tr>
                      <th width="76%" colSpan="2">
                        {panelTitle} - {stepTitle}
                      </th>
                      {checklist && <th width="24%">L1</th>}
                    </tr>
                  </thead>
                  <tbody className="form-table">
                    {isFormalDoVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.formal_do?.name}
                          isRequired={true}
                          className="rto"
                          name="formal_do_doc"
                          disabled={
                            requiredSubStepFields?.formal_do?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.formalDoDoc === "1" ? true : false}
                          noChecked={state.formalDoDoc === "0" ? true : false}
                          onYesClicked={() =>
                            handleInputChange(
                              "formalDoDoc",
                              "1",
                              "showFormalDoDocError"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "formalDoDoc",
                              "0",
                              "showFormalDoDocError"
                            )
                          }
                          showError={state.showFormalDoDocError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="formal_do_doc"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isLosIdVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.los_id?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="bank_los_id"
                              className={`form-control ${
                                state.showLosIdError ? "errorInput" : ""
                              }`}
                              placeholder="LOS ID"
                              required
                              disabled={
                                requiredSubStepFields?.los_id?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.los_id}
                              onChange={(e) =>
                                handleInputChange(
                                  "los_id",
                                  e.target.value,
                                  "showLosIdError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_bank_los_id"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="bank_los_id"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isDisbursementDateVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.disbursement_date?.name}
                        </td>
                        <td>
                          <span>
                            <label>
                              {disbursed_date
                                ? format(new Date(disbursed_date), "dd-MM-yyyy")
                                : ""}
                            </label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="disbursement_picked_date"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isFinancierVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.financier?.name}</td>
                        <td>
                          <span>
                            <label>{bank_name}</label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="bank_id"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isNetAmountVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.net_amount?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="net_disbursement_amount"
                              id="net_disbursement_amount"
                              className={`form-control ${
                                state.showNetAmountError ? "errorInput" : ""
                              }`}
                              placeholder=""
                              required
                              disabled={
                                requiredSubStepFields?.net_amount
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.netDisbursementAmount}
                              onChange={(e) =>
                                handleInputChange(
                                  "netDisbursementAmount",
                                  e.target.value,
                                  "showNetAmountError"
                                )
                              }
                              onBlur={handleBlurNetAmount}
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_net_disbursement_amount"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="net_disbursement_amount"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isLoanSurakshaVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.loan_suraksha?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="deduction_loansuraksha_amount"
                              id="deduction_loansuraksha_amount"
                              className={`form-control calc ${
                                state.showLoanSurakshaError ? "errorInput" : ""
                              }`}
                              placeholder=""
                              required
                              disabled={
                                requiredSubStepFields?.loan_suraksha
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.deductionLoanSurakshaAmount}
                              onChange={(e) =>
                                handleInputChange(
                                  "deductionLoanSurakshaAmount",
                                  e.target.value,
                                  "showLoanSurakshaError"
                                )
                              }
                              onBlur={() =>
                                handleBlurIndividualAmount(
                                  "deductionLoanSurakshaAmount",
                                  "showLoanSurakshaError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_deduction_loansuraksha_amount"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="deduction_loansuraksha_amount"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isStampDutyVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.stamp_duty?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="deduction_stampduty_amount"
                              id="deduction_stampduty_amount"
                              className={`form-control calc ${
                                state.showStampDutyError ? "errorInput" : ""
                              }`}
                              placeholder=""
                              required
                              disabled={
                                requiredSubStepFields?.stamp_duty
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.deductionStampdutyAmount}
                              onChange={(e) =>
                                handleInputChange(
                                  "deductionStampdutyAmount",
                                  e.target.value,
                                  "showStampDutyError"
                                )
                              }
                              onBlur={() =>
                                handleBlurIndividualAmount(
                                  "deductionStampdutyAmount",
                                  "showStampDutyError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_deduction_stampduty_amount"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="deduction_stampduty_amount"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isAdvancedEMIVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.advanced_emi?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="deduction_advemi_amount"
                              id="deduction_advemi_amount"
                              className={`form-control calc ${
                                state.showAdvancedEMIError ? "errorInput" : ""
                              }`}
                              placeholder=""
                              required
                              disabled={
                                requiredSubStepFields?.advanced_emi
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.deductionAdvemiAmount}
                              onChange={(e) =>
                                handleInputChange(
                                  "deductionAdvemiAmount",
                                  e.target.value,
                                  "showAdvancedEMIError"
                                )
                              }
                              onBlur={() =>
                                handleBlurIndividualAmount(
                                  "deductionAdvemiAmount",
                                  "showAdvancedEMIError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_deduction_advemi_amount"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="deduction_advemi_amount"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isOtherDeductionsVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.other_deductions?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="deduction_others_amount"
                              id="deduction_others_amount"
                              className={`form-control calc ${
                                state.showOtherAmountError ? "errorInput" : ""
                              }`}
                              placeholder=""
                              required
                              disabled={
                                requiredSubStepFields?.other_deductions
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.deductionOthersAmount}
                              onChange={(e) =>
                                handleInputChange(
                                  "deductionOthersAmount",
                                  e.target.value,
                                  "showOtherAmountError"
                                )
                              }
                              onBlur={() =>
                                handleBlurIndividualAmount(
                                  "deductionOthersAmount",
                                  "showOtherAmountError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_deduction_others_amount"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="deduction_others_amount"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isGrossAmountVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.gross_amount?.name}</td>
                        <td>
                          <span>
                            <label id="total_sum">{state.grossAmount}</label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="gross_disbursement_amount"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}

                    {isRCUOkVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.rcu_ok?.name}
                          isRequired={true}
                          className="rto"
                          name="clear_rcu_status"
                          disabled={
                            requiredSubStepFields?.rcu_ok?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={
                            state.clearRCUStatus === "1" ? true : false
                          }
                          noChecked={
                            state.clearRCUStatus === "0" ? true : false
                          }
                          onYesClicked={() =>
                            handleInputChange(
                              "clearRCUStatus",
                              "1",
                              "showRCUOkError"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "clearRCUStatus",
                              "0",
                              "showRCUOkError"
                            )
                          }
                          showError={state.showRCUOkError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="clear_rcu_status"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        ) : (
          <div className="disburse-table no-form">
            There are no verification required in this section. Please click
            Next/Skip to proceed
          </div>
        )}
      </div>
      <FormButtons
        caseDetails={caseDetails}
        user={user}
        stepDetails={stepDetails}
        handleNextButtonClick={handleNextStep}
        handleSaveAndNext={handleSaveAndNext}
        handleSaveAsDraft={handleSaveAsDraft}
        isVerificationRequired={calculatedIsVerificationRequired}
        isReadOnlyUser={fieldValues.isReadOnlyUser}
      />
    </>
  );
};

export default DisbursalDetailCheck;
